export default "__VITE_ASSET__1ecxpe4j__"